/**
 * Short-form guest handle: strips the trailing numeric suffix.
 * e.g. 'velvet-jacket-2917' -> 'velvet-jacket'
 * Full handle preserved for identity-badge surfaces (Account, Paywall).
 */
export function shortHandle(handle: string | null | undefined): string {
  if (!handle) return "";
  const parts = handle.split("-");
  if (parts.length >= 3 && /^\d{3,4}$/.test(parts[parts.length - 1])) {
    return parts.slice(0, -1).join("-");
  }
  return handle;
}
